export class Mascaras {

    static decimalToStringBR(valor: string, fixed: number = 2): string {

        if (valor == "")
            valor = "0";

        valor = valor.replace(/[^0-9\.]/g, '');

        var valorFloat: number = parseFloat(valor);
        var valorString: string = valorFloat.toFixed(fixed).toString().replace(/\./g, ",");

        return valorString;
    }

    static decimalToStringEUA(valor: string, fixed: number = 2): string {

        if (valor == "")
            valor = "0";

        valor = valor.replace(/[^0-9\,]/g, '').replace(/\,/g, ".");

        var valorFloat: number = parseFloat(valor);
        var valorString: string = valorFloat.toFixed(fixed).toString();

        return valorString;
    }

    static aplicarMascaraCPF(valor: string) 
    {
        if(valor != "")
            return [valor.slice(0,3) + '.' + valor.slice(3,6) 
                                    + '.' + valor.slice(6,9) + '-' 
                                    + valor.slice(9,11)].join();
    }

    static cep(valor: string): string {
        if (valor == undefined || valor == "") {
            return valor;
        }

        valor = valor.replace(/[^0-9]/g, '');

        var valorArray: string[] = valor.split("");
        var valorStringComMascara: string = "";
        for (var index = 0; index < valorArray.length; index++) {
            valorStringComMascara += valorArray[index];
            if (index == 4) {
                valorStringComMascara += "-";
            }
        }

        return valorStringComMascara;
    }

    static telefone(valor: string): string{
        if (valor == undefined || valor == "") {
                return valor;
            }

            valor = valor.replace(/[^0-9]/g, '');

            var valorArray: string[] = valor.split("");
            var valorStringComMascara: string = "";
            
            for (var index = 0; index < valorArray.length; index++) {
                if (index == 0) {
                    valorStringComMascara += "(";
                }
                valorStringComMascara += valorArray[index];
                if (index == 1) {
                    valorStringComMascara += ") ";
                }
            }
            return valorStringComMascara;
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/masks/mascaras.ts
 **/